export const URL_REGEX =
  /https?:\/\/w{0,3}\w*?\.(\w*?\.)?\w{2,3}\S*|www\.(\w*?\.)?\w*?\.\w{2,3}\S*|(\w*?\.)?\w*?\.\w{2,3}[\/\?]\S*/;

export const TWITTER_REGEX = /^((?!.*(@|http|www).*).)*$/gim;

export const LINKED_IN_URL_REGEX = /^(https?:\/\/)?[a-z]{2,3}\.linkedin\.com\/.*$/gim;
